<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>export default {
  data() {
    return {
      breadcrumb: [
        { name: "人员管理" },
        { name: "业务员管理" },
      ],
      menuIndex: `/staff/salesman/table`,
      menu: [
        {
          name: "在职",
          path: `/staff/salesman/table/1`,
        },
        {
          name: "离职",
          path: `/staff/salesman/table/2`,
        },
        {
          name: "冻结",
          path: `/staff/salesman/table/3`,
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
